const storeObject = {
    user_id: -1,
    mode: null,
    day: {
        payload: {},
        expired: null,
        loaded: null,
        data: [],
    },
    week: {
        payload: {},
        expired: null,
        loaded: null,
        data: [],
    },
    month: {
        payload: {},
        expired: null,
        loaded: null,
        data: [],
    },
    updateLessons: []
};

const state = {
    timetableCache: { ...storeObject }
}

const getters = {
    timetableCache: state => state.timetableCache,
}

const actions = {
    setTimetableCache({ commit }, data = null) {
        commit('setTimetableCache', data)
    },
    logoutTimetableCache({ commit }) {
        commit('logoutTimetableCache')
    },
    addTimetableUpdateLesson({ commit }, ids) {
        commit('addTimetableUpdateLesson', ids)
    },
}

const mutations = {
    setTimetableCache: function (state, data) {
        if (data === undefined || data === null) {
            state.timetableCache.day = {
                payload: {},
                expired: null,
                loaded: null,
                data: [],
            };
            state.timetableCache.week = {
                payload: {},
                expired: null,
                loaded: null,
                data: [],
            };
            state.timetableCache.month = {
                payload: {},
                expired: null,
                loaded: null,
                data: [],
            };
            state.timetableCache.updateLessons = []
        } else {
            const { user_id, mode, key, payload, data: lessonData, refreshExpired, updateLessons, refreshLoaded } = data;
            if (user_id !== undefined && user_id !== null) {
                state.timetableCache.user_id = user_id || -1;
            }
            if (mode !== undefined && mode !== null) {
                state.timetableCache.mode = mode;
            }
            if (updateLessons !== undefined && updateLessons !== null) {
                state.timetableCache.updateLessons = updateLessons || [];
            }

            if (payload !== undefined && payload !== null) {
                state.timetableCache[key].payload = payload || {};
            }
            if (lessonData !== undefined && lessonData !== null) {
                state.timetableCache[key].data = lessonData || [];
            }
            if (refreshExpired !== false) {
                state.timetableCache[key].expired = new Date(new Date().getTime() + 5 * 60 * 1000).getTime();
            }
            if (refreshLoaded != false){
              state.timetableCache[key].loaded = new Date().getTime();
            }
        }
    },
    logoutTimetableCache: function (state) {
        state.timetableCache = { ...storeObject }
    },
    addTimetableUpdateLesson: function (state, ids) {
        const l = [...(state.updateLessons || [])];
        for (let i = 0; i < ids.length; i++) {
            if (!l.includes(ids[i])) {
                l.push(ids[i]);
            }
        }
        state.timetableCache.updateLessons = l;
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}